import { createGlobalStyle } from 'styled-components';

import GothicBold from '@/assets/fonts/centurygothic_bold.ttf';

const VariationsStyles = createGlobalStyle`
  @font-face {
    font-family: 'GothicBold';
    src: url(${GothicBold});
  }   
  
  .generated-images-holder-var26 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1200px;
  }
  .image-holder-var26 {
    width: 100%;
    display: flex;
    position: relative;
    height: 630px;
  }
  .right-text-holder-var26 {
    position: relative;
    background-position: center;
    background-repeat: no-repeat;
    height: 100%;
    width: 50%;
  }
  .right-text-var26 {
    height: 400px;
    overflow: hidden;
    padding: 69px 53px 20px 59px;
    line-height: 1.2;
    width: 100%;
    text-align: center;
    color:  #FF01BA;
    font-family: GothicBold;
    display: flex;
    font-weight: 700;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
  }
  .right-text-glow-var26 {
    height: 400px;
    position: absolute;
    left: 0;
    top: 0;
    overflow: hidden;
    padding: 69px 53px 20px 59px;
    line-height: 1.2;
    width: 100%;
    text-align: center;
    color:  #FC0185;
    font-family: GothicBold;
    display: flex;
    font-weight: 700;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    filter: blur(4px);
  }
  .break-var26 {
    position: absolute;
    width: 12px;
    height: 100%;
    left: 0;
    top: 0;
    right: 0;
    margin-left: calc(50% - 6px);
    z-index: 1;
  }
  .half-image-var26 {
    width: 50%;
    height: 100%;
    object-fit: cover;
    position: relative;
    display: block;
  }
  .actual-photo-var26 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 72px;
  }
  .actual-photo-var26--top {
    top: 0;
    bottom: auto;
  }
`;

export default VariationsStyles;
